// Guard único do Modo Pré-Lançamento no frontend.
//
// Modo OFF                       -> comportamento atual
// Modo ON + não autenticado      -> raiz apresenta o pré-lançamento
// Modo ON + autenticado + tester -> aplicação normal
// Modo ON + autenticado + comum  -> experiência de pré-lançamento
//
// Rotas que continuam acessíveis com o modo ligado: a própria comunicação de
// pré-lançamento, login, cadastro real (paciente e profissional) e todo o
// fluxo de senha. É o espelho da lista de bypass do backend.
export const PRE_LAUNCH_PUBLIC_ROUTES = [
  "PreLaunch",
  "Login",
  "Register",
  "RecoverPassword",
  "UpdatePassword",
  "PasswordMessage",
  "OperatorLogin"
];

// Recebe `getStore` (uma função) e não o store: `router/index.js` e
// `state/store.js` fecham um ciclo de imports (store -> modules/auth -> router),
// então na avaliação do módulo o binding do store ainda pode estar vazio.
// Resolver o store na navegação garante que ele já existe.
export function createPreLaunchGuard(getStore) {
  let bootstrapped = false;

  return function preLaunchGuard(to, from, next) {
    const store = getStore();

    const decide = () => {
      if (!store.getters["preLaunch/blocking"]) return next();
      if (PRE_LAUNCH_PUBLIC_ROUTES.includes(to.name)) return next();

      return next({ name: "PreLaunch" });
    };

    if (bootstrapped) return decide();

    bootstrapped = true;

    return store
      .dispatch("preLaunch/fetchStatus")
      .then(decide)
      .catch(decide);
  };
}
